import * as autoTooltip from './auto-tooltip.directive';

export default angular.module('gazelle.components.autoTooltip', [
  'ngSanitize',
])
  .directive(autoTooltip.name, autoTooltip.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/auto-tooltip/auto-tooltip.module.js